import { anyOf, arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult = objectOf({
  limit: anyOf(number, nullValidation),
  active_count: number,
  unchanged_active_step_ids: arrayOf(string),
  can_free_capacity: maybe(boolean),
  blocking_canvases: maybe(
    arrayOf(
      objectOf({
        c_id: string,
        ag_id: string,
        j_id: string,
        workflow_name: anyOf(string, nullValidation),
      })
    )
  ),
});
